export default {
  Repair: {
    MultiBroken: {
      AddAsset: "Thêm dòng",
      QuickSelect: "Chọn nhanh",
      AssetCode: "Mã tài sản",
      AssetName: "Tên tài sản",
      AssetStatus: "Tình trạng",
      RemainQuantity: "Số lượng",
      Quantity: "Số lượng đánh dấu hỏng",
      Location: "Vị trí tài sản",
      Allocation: "Đối tượng sử dụng",
      Employee: "Nhân viên sử dụng",
      UsedOrganizationUnit: "Đơn vị sử dụng",
      Representative: "Người đại diện",
      QuantityOverload: "Số lượng đánh dấu hỏng hỏng phải thuộc khoảng từ 1 đến ##0##",

      OccurenceDateInValid:
        "Ngày đánh dấu hỏng không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
    },
    Warning: {
      WarningOnlyBrokenTickWhenAlreadyBroken: "Chỉ được đánh dấu hỏng với tài sản báo hỏng.",
      WarningOnlyBrokenDeniedWhenAlreadyBroken: "Chỉ được từ chối báo hỏng với tài sản báo hỏng.",
      WarningOnlyRepairWhenAssetAlreadyBroken:
        "Chỉ được sửa chữa với tài sản chưa sử dụng, đang sửa dụng, báo hỏng, đã hỏng",
      WarningOnlyReuseWhenAssetIsRepairing:
        "Chỉ được đưa vào sử dụng lại với tài sản đang sửa chữa.",
      WarningAssetIsRepairing: "Tài sản đang thực hiện sửa chữa. Vui lòng chọn tài sản khác.",
      WarningOnlyTickBrokenAsset: "Chỉ được đánh dấu hỏng các tài sản báo hỏng",
      WarningOnlyTickBrokenAssetContinue:
        "Chỉ được đánh dấu hỏng với tài sản báo hỏng, bạn có muốn tiếp tục không",
      ErrorCanNotScheduleRepairAsset:
        "Chỉ được lập lịch sửa chữa với tình trạng khác đang sửa chữa",
    },
  },
  Maintain: {
    Warning: {
      WarningAssetIsMaintaining: "Tài sản đang thực hiện bảo dưỡng. Vui lòng chọn tài sản khác.",
      WarningOnlyReuseWhenAssetIsMaintaining:
        "Chỉ được đưa vào sử dụng lại với tài sản đang bảo dưỡng.",
    },
  },
};
